export const isUseProductionEnv = process.env.NEXT_PUBLIC_USE_PRODUCTION_ENV === '1';
